import Icon from '../components/Icon.vue'

Icon.register({
  'fire-extinguisher': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M434 26.3L266 54.3C254.7 56.2 256 67.8 256 72H197.7C208.4 36.1 181.4 0 144 0 104.6 0 77.6 39.7 91.8 76.2 39.7 89.3 16.4 130.4 1.7 167.1-3.2 179.4 2.8 193.4 15.1 198.3 27.4 203.2 41.4 197.2 46.3 184.9 75.1 113 107 120 168 120V147.1C126.5 157.9 96 196.3 96 241.2V488C96 501.3 106.7 512 120 512H264C277.3 512 288 501.3 288 488V240C288 195.3 257.4 157.7 216 147V120H256C256 123 254.3 135.7 266 137.7L434 165.7C441.3 166.9 448 161.3 448 153.8V38.2C448 30.8 441.3 25.1 434 26.3zM144 72C135.2 72 128 64.8 128 56S135.2 40 144 40 160 47.2 160 56 152.8 72 144 72z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fire-extinguisher.js
// module id = /k6U
// module chunks = 144